/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import React from 'react'
import Tooltip from 'DesignSystem/Tooltip/index'
import TysiaIconExpand from 'DesignSystem/Svgs/TysiaIconExpand/index'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Calendar/New/Content/Content/Calendar/Content/Content/Topbar/UpperSection/SidebarExpandAction/Content",
  fill2
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
let onClick = fromHelpers.useOnClick({
  children,
  viewPath,
  fill2
  
})
let onMouseEnter = fromHelpers.useOnMouseEnter({
  children,
  viewPath,
  fill2
  
})
let onMouseLeave = fromHelpers.useOnMouseLeave({
  children,
  viewPath,
  fill2
  
})
let tabSidebarIsFloatingAndVisibleValueData = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'sidebar.is_floating_and_visible',
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let tabSidebarIsFloatingAndVisibleValueData1 = fromData.useDataValue({ viewPath,
context: 'tab',
path: 'sidebar.is_floating_and_visible',
})
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
  return (<React.Fragment
>
<button
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 onMouseEnter={onMouseEnter}
 onMouseLeave={onMouseLeave}
 className={`views-block ${styles.Vertical}`}
>
<TysiaIconExpand
  viewPath={`${viewPath}/TysiaIconExpand`}
 fill2={tabSidebarIsFloatingAndVisibleValueData ? dtColorsNeutral900 : fill2}
 data="tab.sidebar.is_floating_and_visible"
/>
<fromFlow.When is={tabSidebarIsFloatingAndVisibleValueData1}>
<Tooltip
  viewPath={`${viewPath}/Tooltip`}
 size="medium"
 top={0}
 left={dtSpaceM}
 right={dtSpaceL}
 height="auto"
 maxWidth={200}
 backgroundColor={dtColorsNeutral100}
 color={dtColorsBlack}
 whiteSpace="wrap"
 text="Expand Calendar view"
 data="tab.sidebar.is_floating_and_visible"
/>
</fromFlow.When>
</button>
{children}
</React.Fragment>)
}